import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';

import { CoreModule } from '@atmi/core/core.module';
import { basePath } from '@atmi/core/injection';
import { ResponsePaginateSuccess, ResponseSuccess } from '@atmi/core/models';
import { generateIndexQueryString, IndexQueryStringType } from '@atmi/core/utils';

import { Person } from '@sim/person/models/person';

@Injectable({
  providedIn: CoreModule,//https://angular.io/guide/update-to-version-15#v15-dp-04
})
export class PersonApiService {
  private readonly path = `${this.baseUrl}/persone`;

  constructor(
    @Inject(basePath) private readonly baseUrl: string,
    private readonly http: HttpClient,
  ) {
  }


  index(queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<Person[]>>(this.path, { params });
  }

  get(id: string) {
    return this.http.get<ResponseSuccess<Person>>(`${this.path}/${id}`).pipe(
      map((res) => res.data),
    );
  }

  post(collection: Partial<Person>) {
    return this.http.post<ResponseSuccess<Person>>(this.path, collection).pipe(
      map((res) => res.data),
      first(),
    );
  }

  put(person: Person) {
    return this.http.put<ResponseSuccess<Person>>(`${this.path}/${person.id}`, person).pipe(
      map((res) => res.data),
      first(),
    );
  }

  remove(id: string) {
    return this.http.delete(`${this.path}/${id}`).pipe(first());
  }
}
